/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request object for an institute email
 * @export
 * @interface InstituteEmailRequest
 */
export interface InstituteEmailRequest {
    /**
     * email of the institute
     * @type {string}
     * @memberof InstituteEmailRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the InstituteEmailRequest interface.
 */
export function instanceOfInstituteEmailRequest(value: object): value is InstituteEmailRequest {
    return true;
}

export function InstituteEmailRequestFromJSON(json: any): InstituteEmailRequest {
    return InstituteEmailRequestFromJSONTyped(json, false);
}

export function InstituteEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function InstituteEmailRequestToJSON(json: any): InstituteEmailRequest {
    return InstituteEmailRequestToJSONTyped(json, false);
}

export function InstituteEmailRequestToJSONTyped(value?: InstituteEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

